export function registerServiceWorker() {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const serviceWorkerUrl = new URL('sw.js', window.location.href);

    void navigator.serviceWorker.register(serviceWorkerUrl).catch(() => {
      // Offline support is best-effort; the app remains usable without registration.
    });
  });
}
